var acTooltop = acTooltop || {};

if (!Object.create) {
    Object.create = (function () {
        function F() {}

        return function (o) {
            if (arguments.length != 1) {
                throw new Error('Object.create implementation only accepts one parameter.');
            }
            F.prototype = o;
            return new F()
        }
    })()
}

jQuery(function ( $ ) {
 
    $.fn.acTool = function( options ) {
        return this.each(function() {
            var acTool = Object.create(acTooltop.acTool);
            acTool.init(this, options);
        });
    };

    $.fn.acTool.options = {

     };

    acTooltop.acTool = {
        
        
        init (elem, options) {
            var self = this;
            self.$container = $(elem);
            self.options = $.extend({}, $.fn.showHide.options, options);
            self.$trigger = self.$container.find(".hero-tooltip__button")
            self.$content = self.$container.find(".hero-tooltip__content")
            self.bindElements();
        },

        bindElements () {
            var self = this;
            
            self.$trigger.on("click", function() {
                self.$content.fadeToggle( 300 )
            })

            $(window).on("scroll", function() {
                if( self.$content.is(":visible") ) {
                    
                    self.$content.fadeOut(300);
                }
            })
            
        },

        toggle(e) {
            var self = this;
            if ( e ) {
                self.$container.fadeIn( 300 )
            } else {
                self.$container.fadeOut( 300 )
            }
        }
    }
});
